"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const StyledLink = (0, material_1.styled)('a')(() => ({
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
        color: 'darkblue',
        textDecoration: 'underline',
    },
}));
const Error = () => {
    const feesableEmail = 'support@feesable.com.au';
    return ((0, jsx_runtime_1.jsxs)(Grid_1.default, { container: true, spacing: 2, p: 5, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", mt: "20px", mb: "40px", children: "Sorry, we don't recognise that School ID." }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "h5", children: ["Please get in touch with", ' ', (0, jsx_runtime_1.jsx)(StyledLink, { href: `mailto:${feesableEmail}`, children: feesableEmail }), ' ', "for a valid school ID. If you wish to learn more about school fees, please contact the school directly."] })] }));
};
exports.default = Error;
